// SPDX-License-Identifier: AGPL-3.0-or-later

import {refreshRoomCharacter} from '@app/features/voice_scene/commands/VoiceSeatCommands';
import {useEffect, useRef} from 'react';

// Times after the room opens. The join webhook writes my character attribute; it can drop, so the client asks again.
export const CHARACTER_REFRESH_DELAYS_MS = [3000, 10000, 30000] as const;

// Tries only while my own `micup.character` is missing, at most three times per connection.
export function useCharacterRefreshFallback({
	channelId,
	connectionId,
	present,
}: {
	channelId: string;
	connectionId: string | null;
	present: boolean;
}): void {
	const latest = useRef(present);
	latest.current = present;
	useEffect(() => {
		if (!connectionId) return;
		const timers = CHARACTER_REFRESH_DELAYS_MS.map((delay) =>
			setTimeout(() => {
				if (latest.current) {
					for (const timer of timers) clearTimeout(timer);
					return;
				}
				void refreshRoomCharacter(channelId);
			}, delay),
		);
		return () => {
			for (const timer of timers) clearTimeout(timer);
		};
	}, [channelId, connectionId]);
}
